import axios from 'axios'
//This module create an axios interceptor used at every request sent to the back 
//to manage access and refresh token to authenticate user

const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if(error.response.status === 401){
        return new Promise((resolve) => {
          const originalRequest = error.config
          const refreshToken = localStorage.getItem('refresh_token')
          if(error.config.__isRetryRequest && !error.config.url.startsWith("https://LaurenceBrun.eu.pythonanywhere.com/paymentCheck/")){
            return Promise.reject(error).catch((error) => {
              //Clear access_token, refresh_token, username, userId, userIsStaff
              localStorage.clear()
              alert('Vous avez été déconnecté suite à une trop longue inactivité.')
              window.location.reload()
            })
          }
          if ((error.config && !error.config.__isRetryRequest && refreshToken) || (error.config.url.startsWith("https://LaurenceBrun.eu.pythonanywhere.com/paymentCheck/") && !error.config.__isPCRetryRequest01256)) {
            error.config.url.startsWith("https://LaurenceBrun.eu.pythonanywhere.com/paymentCheck/") ? originalRequest.__isPCRetryRequest01256 = true : originalRequest.__isRetryRequest = true
            const response = axios("https://LaurenceBrun.eu.pythonanywhere.com/auth/token/refresh/", {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              data: JSON.stringify({
                'refresh': refreshToken,
              }),
            })
              .then((res) => {
                localStorage.setItem('access_token', res.data.access)
                originalRequest.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`
                return axios(originalRequest)
              })
              .catch((err)=>{
                //Clear access_token, refresh_token, username, userId, userIsStaff
                localStorage.clear()
                alert('Vous avez été déconnecté suite à une trop longue inactivité.')
                window.location.reload()
              })
            resolve(response)
          }
        })
      }
      else{
        return error
      }
    },
  )

  export default axiosInstance
  